import { isAxiosError } from "axios";

import { isAxiosBffError } from "./is-axios-bff-error";

export const getErrorTextByError = (error: unknown): string | undefined => {
  if (
    isAxiosError<{ message?: string }>(error) &&
    error.response?.data?.message
  )
    return error.response.data.message;
  if (!isAxiosBffError(error)) return undefined;
  const { title } = error.response?.data || {};
  return title;
};
